import {
  Box,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import { useAppDispatch, useAppSelector } from '../../../../../app/redux/hooks';
import CustomIconButton from '../../../../../common/components/buttons/CustomIconButton';
import constants from '../../../../../utils/constants';
import CustomButton from '../../../../../common/components/buttons/CustomButton';
import CustomDataGrid from '../../../../../common/components/customized/customdatagrid/CustomDataGrid';
import AddCustomerDelivery from './AddCustomerDelivery';
import CustomDeletePopup from '../../../../../common/components/customdelete/CustomDeletePopup';
import './CustomerDelivery.scss';
import {
  deleteCustomer,
  getCustomersAction
} from '../../../redux/reducer/deliveryTrackingSlices/customerDeliverySlice';
import { usePagination } from '../../../../../utils/commonFunctions';

const CustomerDelivery = () => {
  const [type, setType] = useState<string>('');
  const [open, setOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const [filteredRow, setFilteredRow] = useState<null | any>();
  const [rows, setRows] = useState<any>([]);
  const [role, setRole] = useState<string>('');
  const [label, setLabel] = useState('');

  const { pageSize, pageNo, pagination } = usePagination(5, 1);

  const dispatch = useAppDispatch();

  const { data, isLoading, count } = useAppSelector(state => state.customerGet);
  const { isLoading: deleteLoading } = useAppSelector(state => state.customerDelete);
  const isOpen = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUpdate = (params: any) => {
    setFilteredRow(params);
  };

  // handle delete
  const handleDelete = async () => {
    if (filteredRow && filteredRow?.customerId) {
      await dispatch(
        deleteCustomer({ customerId: filteredRow?.customerId, pageNo, pageSize })
      );
    }
    setIsDelete(false);
  };

  //function to handle Pagination
  const handlePagination = async (newPaginationModel: {
    page: number;
    pageSize: number;
  }) => {
    await dispatch(getCustomersAction(pagination(newPaginationModel)));
  };

  useEffect(() => {
    if (data?.length > 0) {
      setRows(data);
    } else if (data?.length === 0) {
      setRows([]);
    }
  }, [data]);

  useEffect(() => {
    dispatch(getCustomersAction({ pageNo, pageSize }));
  }, []);

  let columns = [
    {
      field: 'firstName',
      headerName: `First Name`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'lastName',
      headerName: `Last Name`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'contactNumber',
      headerName: `Contact Number`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'deliveryAddress',
      headerName: `Delivery Address`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      minWidth: 150,
      renderCell: ({ row }: any) => (
        <Box>
          <Tooltip title='Menu' placement='right' arrow>
            <IconButton
              id='basic-button'
              sx={{ display: 'flex', justifyContent: 'flex-start', pl: 0 }}
              aria-controls={isOpen ? 'basic-menu' : undefined}
              aria-haspopup='true'
              aria-expanded={isOpen ? 'true' : undefined}
              onClick={event => {
                setRole(row?.roleType);
                setLabel(`Update Customer`);
                setType(`Update Customer`);
                handleUpdate(row);
                setFilteredRow(row);
                setAnchorEl(event.currentTarget);
              }}
            >
              <Icon icon='eva:menu-2-outline' className='white-bg' />
            </IconButton>
          </Tooltip>
          <Menu anchorEl={anchorEl} open={isOpen} onClose={handleClose}>
            <MenuItem
              onClick={() => {
                setIsUpdate(true);
                setOpen(true);
                handleClose();
              }}
            >
              <CustomIconButton category='Update' showTooltip={false} /> {''}
              {constants.Update}
            </MenuItem>
            <MenuItem
              onClick={() => {
                setIsDelete(true);
                setMessage(`${constants.DeleteCustomer} Customer?`);
                handleClose();
              }}
            >
              <CustomIconButton category='Delete' showTooltip={false} /> {''}
              {constants.Delete}
            </MenuItem>
          </Menu>
        </Box>
      )
    }
  ];

  return (
    <Box className='customer-delivery'>
      <Box>
        <Box className='customer-title'>
          <CustomButton
            category={'Add Customer'}
            className='saveChanges'
            onClick={() => {
              setOpen(true);
              setRole('Add Customer');
              setFilteredRow(null);
              setType('Add Customer');
              setLabel('Add Customer');
            }}
          />
        </Box>
      </Box>
      <Box sx={{ marginTop: '20px' }}>
        <CustomDataGrid
          rows={rows}
          columns={columns}
          loading={isLoading}
          onPaginationModelChange={handlePagination}
          rowCount={count}
          pageNo={pageNo}
          pageSize={pageSize}
          type={'autoplanner'}
          paginationModel={{
            page: pageNo ? pageNo - 1 : 0,
            pageSize: pageSize
          }}
        />
      </Box>
      {open && (
        <AddCustomerDelivery
          open={open}
          setOpen={setOpen}
          roleType={type}
          filteredRow={filteredRow}
        />
      )}

      {isDelete && (
        <CustomDeletePopup
          open={isDelete}
          setOpen={setIsDelete}
          handleDelete={handleDelete}
          handleClose={handleClose}
          message={message}
          isLoading={deleteLoading}
        />
      )}
    </Box>
  );
};

export default CustomerDelivery;
